import { api } from '$app/api';

const PriceFormToApi = price => parseInt(parseFloat(price, 10) * 100);
const PriceApiToForm = price => (price/100).toFixed(2).toString();

const PercentageToApi = value => parseFloat(value) / 100;
const ApiToPercentage = value => (parseFloat(value) * 100).toString();

const percentageTypes = ['Fixter C&D fee', 'Booking Fee Percentage']

const priceOrPercentageValue = op =>
percentageTypes.includes(op.operationId) ?
    ApiToPercentage(op.price) :
    PriceApiToForm(op.price);

const addType = op => {
  if (percentageTypes.includes(op.operationId)) op.type = 'percentage';
  else op.type = 'price';
  return op;
}

export function getOperationForGarage(garageId) {
  return api.get(`/garage-operations/garages/${garageId}/operations`)
    .then(({ data }) => Object.values(data[garageId]).map(op => {
        op.price = priceOrPercentageValue(op);
        addType(op);

        return op;
      }), (err) => {
        if (err.response.status == 404) return []

        throw err;
      });
}

export function patchGarageOperation(garageId, operation) {
  operation = Object.assign({}, operation);

  operation.price = operation.type === 'percentage' ?
    PercentageToApi(operation.price) :
    PriceFormToApi(operation.price);

  delete operation.type;


  return api.patch(`/garage-operations/garages/${garageId}/operations`, operation);
}

export function deleteGarageOperation(garageId, operation) {
  operation = Object.assign({}, operation);

  operation.price = priceOrPercentageValue(data);

  return api.delete(`/garage-operations/garages/${garageId}/operations`, { data: operation });
}

export function createGarageOperation(garageId, operation) {
  operation = Object.assign({}, operation);

  operation.price = operation.type === 'percentage' ?
    PercentageToApi(operation.price) :
    PriceFormToApi(operation.price);

  delete operation.type;

  return api.post(`/garage-operations/garages/${garageId}/operations`, operation)
    .then(({ data }) => {
      data.price = priceOrPercentageValue(data);
      addType(data);

      return data;
    });
}
